<template>
  <v-content>
    <v-container fluid class="fullsize-container" id="top">
      <v-row style="height: 100%">
        <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="col-xs-10" align-self="center">
          <div id="content-div">
            <div class="container-row">
              <LoginContent :loggedIn="isLoggedIn" />
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import { mapState } from "vuex";
import LoginContent from "@/components/landing/LoginContent";

export default {
  name: "LandingPage",
  data() {
    return {
      apiUrl: process.env.VUE_APP_SO_API_BASE_URL,
      isLoggedIn: false
    };
  },
  components: {
    LoginContent
  },

  computed: {
    ...mapState("users", { userStatus: "status" })
  },

  created() {
    if (this.userStatus) {
      this.isLoggedIn = this.userStatus.loggedIn;
    } else {
      this.isLoggedIn = false;
    }
  }
};
</script>

<style scoped>
.lang-switch-container {
  position: fixed;
  width: 100px;
  top: 0;
  right: 0;
  margin: 2rem;
  color: white;
}

.max-50 {
  max-width: 50% !important;
}

.so-title {
  font-size: 3rem;
}

.fullsize-container {
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  background-image: url("/landing-bg.jpg");
  background-position-x: center;
  background-size: cover;
}

.content-div {
  width: 80%;
  height: 100vh;
  display: block;
}

.container-row {
  margin: 0 auto;
  width: 70%;
}

.phone-container {
  align-content: right;
  width: 50%;
  height: 90%;
  margin: 10%;
}

.phone {
  width: auto;
  height: 100%;
  background-image: url("/sensorphone.png");
  background-position: center;
  background-size: contain;
}

.phone-api {
  width: auto;
  height: 100%;
  background-image: url("/sensorphone-api.png");
  background-position: center;
  background-size: contain;
  -webkit-animation: scaleBreath 10s ease-out infinite normal;
  -moz-animation: scaleBreath 10s ease-out infinite normal;
  -ms-animation: scaleBreath 10s ease-out infinite normal;
  -o-animation: scaleBreath 10s ease-out infinite normal;
  animation: scaleBreath 10s ease-out infinite normal;
}

.button-breathing {
  -webkit-animation: colorBreath 5s ease-out infinite normal;
  -moz-animation: colorBreath 5s ease-out infinite normal;
  -ms-animation: colorBreath 5s ease-out infinite normal;
  -o-animation: colorBreath 5s ease-out infinite normal;
  animation: colorBreath 5s ease-out infinite normal;
}

.hidesmall {
  display: inline-flex;
  display: -ms-inline-flexbox;
  display: -moz-inline-box;
  display: -webkit-inline-flex;
}
@media only screen and (max-width: 800px) {
  .container-row {
    margin-top: 7rem;
    width: 90%;
    margin: 7rem auto;
  }

  .pcc {
    display: none;
  }

  .phone-container {
    width: 100% !important;
  }
}

@media only screen and (max-width: 1400px) {
  .phone-container {
    width: 90% !important;
  }
}

@-webkit-keyframes colorBreath {
  0% {
    background-color: #7ca6d8;
  }

  10% {
    background-color: #97bae5;
  }

  30% {
    background-color: #bdd5f1;
  }

  50% {
    background-color: #e3f0ff;
    color: #bdd5f1;
  }

  70% {
    background-color: #bdd5f1;
  }

  80% {
    background-color: #97bae5;
  }

  100% {
    background-color: #7ca6d8;
  }
}

@-webkit-keyframes scaleBreath {
  0% {
    -webkit-transform: scale(0.9);
    -moz-transform: scale(0.9);
    -ms-transform: scale(0.9);
    -o-transform: scale(0.9);
    transform: scale(0.9);
  }

  25% {
    -webkit-transform: scale(0.95);
    -moz-transform: scale(0.95);
    -ms-transform: scale(0.95);
    -o-transform: scale(0.95);
    transform: scale(0.95);
  }

  50% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }

  75% {
    -webkit-transform: scale(0.95);
    -moz-transform: scale(0.95);
    -ms-transform: scale(0.95);
    -o-transform: scale(0.95);
    transform: scale(0.95);
  }

  100% {
    -webkit-transform: scale(0.9);
    -moz-transform: scale(0.9);
    -ms-transform: scale(0.9);
    -o-transform: scale(0.9);
    transform: scale(0.9);
  }
}
</style>